import React from "react";
import { ThemePalette } from "../../../../theme";
import { PropelBusySvg } from "./BusyIndicator.styles";
import { BusyIndicatorProps, BusyIndicatorTypes } from "./BusyIndicator.types";

export const BusyIndicator = ({
  size = BusyIndicatorTypes.medium,
  color,
}: BusyIndicatorProps) => {
  const renderSvg = () => (
    <PropelBusySvg
      className="Rectangle-Loader"
      width={size}
      height="100%"
      viewBox="0 0 135 80"
      xmlns="http://www.w3.org/2000/svg"
      fillColor={color}
      theme={ThemePalette}
    >
      <rect x="30" y="0" width="20" height="80">
        <animate
          attributeName="height"
          from="80"
          to="80"
          begin="0s"
          dur="1s"
          values="80;10;80"
          calcMode="linear"
          repeatCount="indefinite"
        />

        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="60" y="0" width="20" height="80">
        <animate
          attributeName="height"
          from="80"
          to="80"
          begin="0.2s"
          dur="1s"
          values="10;80;10"
          calcMode="linear"
          repeatCount="indefinite"
        />

        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0.2s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="90" y="0" width="20" height="80">
        <animate
          attributeName="height"
          from="80"
          to="80"
          begin="0.4s"
          dur="1s"
          values="80;10;80"
          calcMode="linear"
          repeatCount="indefinite"
        />

        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0.4s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </rect>
    </PropelBusySvg>
  );
  return renderSvg();
};
